import { DateRangeFilterEnum as a, DateRangeCustomFilterEnum as s } from "../enum/date-range-filter-enum.mjs";
const p = {
  [a.Last30Days]: "public_pages_purchase.date_picker.last_30_days",
  [a.ThisMonth]: "public_pages_purchase.date_picker.this_month",
  [a.LastMonth]: "public_pages_purchase.date_picker.last_month"
}, _ = {
  [s.AllTime]: "public_pages_purchase.date_picker.all_time",
  [s.Last3Months]: "public_pages_purchase.date_picker.last_3_months",
  [s.EvaluationPeriod]: "public_pages_purchase.date_picker.last_pool_period"
}, o = (e, t) => t(p[e]), c = (e, t) => t(_[e]);
export {
  _ as dateRangeCustomFilterLocoKeys,
  p as dateRangeFilterLocoKeys,
  c as getDateRangeCustomFilterName,
  o as getDateRangeFilterName
};
